export default {
	list_tiket: {
		meta: {
			code: 200,
			msg: "success",
		},
		data: [
			{
				name: "Test Ticket 2",
				ticket_status: "available",
				unique_code: "FDEVT-1002",
				type: "3 day",
				claimed_by: null,
			},
			{
				name: "Test Ticket 1",
				ticket_status: "owned",
				unique_code: "FDEVT-1001",
				type: "1 day",
				claimed_by: {
					id: 11,
					name: "Dyo",
					etc: "etc",
				},
			},
		],
		pagination: {
			page: 1,
			total: 2,
			total_page: 1,
		},
	},

	CONFIG_SIDEBAR: [
		{
			name: "BANDUNG X BEAUTY",
			value: "Bandung-x-beauty",
			pathname: `${process.env.NEXT_PUBLIC_YXB_DOMAIN}`,
			query: "",
			visible: true,
			new: true,
		},
		{
			name: "REVIEWS",
			value: "reviews",
			pathname: process.env.NEXT_PUBLIC_REVIEWS_DOMAIN,
			query: "order=newest",
			visible: true,
			new: false,
		},
		{
			name: "EDITORIAL",
			value: "editorial",
			pathname: process.env.NEXT_PUBLIC_EDITORIAL_DOMAIN,
			query: "order=newest",
			visible: true,
			new: false,
		},
		{
			name: "SHOP AT FEMALE DAILY STUDIO",
			value: "studio",
			pathname: process.env.NEXT_PUBLIC_ECM_DOMAIN,
			query: "page=1",
			visible: true,
			new: false,
		},
		{
			name: "TALK",
			value: "talk",
			pathname: process.env.NEXT_PUBLIC_TALK_DOMAIN,
			query: "page=1",
			visible: true,
			new: false,
		},
		{
			name: "TRY & REVIEW",
			value: "try-and-review",
			pathname: `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/try-and-review`,
			query: "",
			visible: true,
			new: false,
		},
	],

	MENU: {
		title_menu: {
			text: "Download Female Daily App",
			link: {
				desktop: process.env.APP_DOMAIN,
				mobile: {
					android:
						"https://play.google.com/store/apps/details?id=com.fdbr.android",
					ios: "https://apps.apple.com/id/app/female-daily-beauty-review/id1160742672",
				},
			},
		},
		menus: [
			{
				text: "FEMALE DAILY",
				link: process.env.NEXT_PUBLIC_ROOT_HOME,
				id: "id_lblfemaledaily",
				new: false,
			},
			{
				text: "REVIEWS",
				link: process.env.NEXT_PUBLIC_REVIEWS_DOMAIN,
				id: "id_lbreviews",
				new: false,
			},
			{
				text: "EDITORIAL",
				link: process.env.NEXT_PUBLIC_EDITORIAL_DOMAIN,
				id: "id_lbeditorial",
				new: false,
			},
			{
				text: "FEMALE DAILY STUDIO",
				link: process.env.NEXT_PUBLIC_ECM_DOMAIN,
				id: "id_lbshop",
				new: false,
			},
			{
				text: "TALK",
				link: process.env.NEXT_PUBLIC_TALK_DOMAIN,
				id: "id_lbtalk",
				new: false,
			},
			{
				text: "TRY AND REVIEW",
				link: `${process.env.NEXT_PUBLIC_ROOT_HOME}/try-and-review`,
				id: "id_lbtryreview",
				new: false,
			},
			{
				text:
					process.env.NEXT_PUBLIC_ALLO_STATUS === "ON"
						? "ALLO EXPLORE"
						: null,
				id: null,
				new: false,
				image:
					process.env.NEXT_PUBLIC_ALLO_STATUS === "ON"
						? "https://image.femaledaily.com/web-assets/allo_explore_white.svg"
						: null,
			},
		],
	},

	INSTRUCTION: [
		{
			id: 1,
			title: "Memiliki Aplikasi Female Daily",
			content:
				"Pastikan kamu sudah mendownload aplikasi Female Daily di handphone kamu ya.",
		},
		{
			id: 2,
			title: "Memiliki Akun Female Daily",
			content:
				"Pastikan kamu sudah memiliki akun Female Daily. Jika belum, kamu bisa melakukan registrasi setelah kamu mendownload aplikasi Female Daily.",
		},
		{
			id: 3,
			title: "Login ke dalam aplikasi ",
			content:
				"Pastikan kamu sudah berhasil login ke dalam aplikasi Female Daily menggunakan akun yang sudah kamu registrasi sebelumnya.",
		},
	],

	TERMS_AND_CONDITION: [
		{
			id: 1,
			title: "Syarat & Ketentuan Female Daily x Beauty 2025",
			content: [
				"Tidak menerima klaim tiket ataupun exclusive tote bag setelah acara selesai",
				"Tidak menerima pengiriman tiket ataupun exclusive tote bag sebelum hari H event",
				"Tiket hanya dapat dibeli di Female Daily Studio dan Livin' Sukha by Mandiri",
				"Anak di bawah 12 tahun tidak perlu beli tiket",
				"Tiket yang sudah dibeli tidak dapat di-refund/dibatalkan/di-upgrade",
				"Skenario 1: Penyelenggara acara tidak bertanggung jawab atas kerusakan atau kehilangan gelang tiket yang disebabkan oleh kelalaian pengunjung",
				"Skenario 2: Apabila gelang tiket yang sudah diberikan hilang, maka tidak ada penggantian gelang",
				"Apabila tiket hilang, rusak ataupun salah bawa gelang, maka pengunjung wajib membeli tiket kembali",
				"Tiket digital dan gelang tiket hanya berfungsi sebagai akses untuk masuk ke venue, bukan untuk mendapatkan benefit lain",
			],
		},
		{
			id: 2,
			title: "Kegunaan QR Code",
			content: [
				"Mendapatkan gelang untuk masuk ke dalam area acara Female Daily x Beauty 2025",
				"Menukarkan Goodie Bag (Bag only, tanpa produk), bagi pemiliki tiket dengan kategori Platinum",
			],
		},
	],
	MANDIRI_HAVE_ACC: [
		{
			id: 1,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/mandiri/1.png",
			content: "Buka email pembelian tiket",
		},
		{
			id: 2,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/mandiri/2.png",
			content: "Klik button \"Lihat E- Voucher\"",
		},
		{
			id: 3,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/mandiri/3.png",
			content: "Klik salah satu link tiket",
		},
		{
			id: 4,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/mandiri/4.png",
			content:
				"Untuk klaim tiket, pilih button “Ya”",
		},
		{
			id: 5,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/mandiri/5.png",
			content:
				"Tiket yang berhasil diklaim akan menampilkan button \"Tampilkan QR\". Klik untuk menampilkan QR code",
		},
		{
			id: 6,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/mandiri/6.png",
			content:
				"Kamu akan diarahkan ke dalam halaman yang berisikan QR Code, Live Stream Player, dan Chat Box",
		},
		{
			id: 7,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/mandiri/7.png",
			content:
				"Tunjukkan QR code untuk menukarkan gelang di venue Female Daily x Beauty",
		},
	],
	MANDIRI_NO_ACC: [
		{
			id: 1,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/no-account/1.png",
			content: "Buka email pembelian tiket",
		},
		{
			id: 2,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/no-account/2.png",
			content: "Klik button Lihat E-Voucher",
		},
		{
			id: 3,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/no-account/3.png",
			content: "Klik salah satu link tiket",
		},
		{
			id: 4,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/no-account/4.png",
			content: "Download aplikasi Female Daily dari App Store atau Play Store.",
		},
		{
			id: 5,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/no-account/5.png",
			content: "Install aplikasi Female Daily dan buat akun baru.",
		},
		{
			id: 6,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/no-account/6.png",
			content: "Kembali ke email dan klik link e-tiket",
		},
		{
			id: 7,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/no-account/7.png",
			content:
				"Untuk klaim tiket, pilih button “Ya”",
		},
		{
			id: 8,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/no-account/8.png",
			content:
				"Tiket yang berhasil diklaim akan menampilkan button \"Tampilkan QR\". Klik untuk menampilkan QR code",
		},
		{
			id: 9,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/no-account/9.png",
			content:
				"Kamu akan diarahkan ke dalam halaman yang berisikan QR Code, Live Stream Player, dan Chat Box",
		},
		{
			id: 10,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/no-account/10.png",
			content:
				"Tunjukkan QR code untuk menukarkan gelang di venue Female Daily x Beauty",
		},
	],

	INSTRUCTIONS_APP: [
		{
			id: 1,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/claim/1.png",
			content:
				"Buka aplikasi Female Daily, lalu buka menu FD Event pada homepage",
		},
		{
			id: 2,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/claim/2.png",
			content:
				"Pilih event yang sesuai dengan jenis tiket yang dibeli.",
		},
		{
			id: 3,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/claim/3.png",
			content:
				"Pilih tiket yang sesuai di halaman My Tickets. Pilih \"Klaim Tiket\"",
		},
		{
			id: 4,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/claim/4.png",
			content: "Untuk klaim tiket, pilih button “Ya”",
		},
		{
			id: 5,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/claim/5.png",
			content:
				"Tiket yang berhasil diklaim akan menampilkan button \"Tampilkan QR\". Klik untuk menampilkan QR code",
		},
		{
			id: 6,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/claim/6.png",
			content:
				"Kamu akan diarahkan ke dalam halaman yang berisikan QR Code, Live Stream Player, dan Chat Box",
		},
		{
			id: 7,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/claim/7.png",
			content:
				"Tunjukkan QR code untuk menukarkan gelang di venue Female Daily x Beauty",
		},
	],

	INSTRUCTIONS_TICKET: [
		{
			id: 21,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/share-instruction-claim-ticket-v2/1.png",
			content: "Klik link tiket yang kamu miliki",
		},
		{
			id: 22,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/share-instruction-claim-ticket-v2/2.png",
			content:
				"Kamu akan diarahkan ke dalam aplikasi Female Daily. Klik button “Ya” untuk klaim tiket.",
		},
		{
			id: 23,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/share-instruction-claim-ticket-v2/3.png",
			content:
				"Tiket yang berhasil diklaim akan menampilkan button \"Tampilkan QR\". Klik untuk menampilkan QR code.",
		},
		{
			id: 24,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/share-instruction-claim-ticket-v2/4.png",
			content:
				"Kamu akan diarahkan ke dalam halaman yang berisikan QR Code, Live Stream Player, dan Chat Box",
		},
		{
			id: 25,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/share-instruction-claim-ticket-v2/5.png",
			content:
				"QR Code digunakan untuk menukarkan gelang di venue Female Daily  X Beauty 2023",
		},
	],

	INSTRUCTIONS_SHARE: [
		{
			id: 31,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/share/1.png",
			content:
				"Buka aplikasi Female Daily, lalu buka menu FD Event pada homepage",
		},
		{
			id: 32,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/share/2.png",
			content:
				"Pilih event yang sesuai dengan jenis tiket yang dibeli.",
		},
		{
			id: 33,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/share/3.png",
			content:
				"Klik tombol Share pada tiket yang ingin kamu bagikan",
		},
		{
			id: 34,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/share/4.png",
			content:
				"Pilih aplikasi yang mau kamu gunakan untuk mengirim link tiket kepada teman kamu (Contoh: Whatsapp)",
		},
		{
			id: 35,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/share/5.png",
			content:
				"Tiket akan diterima dalam bentuk link.",
		},
		{
			id: 36,
			img: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/xbeauty/2025/ticket/share/6.png",
			content:
				"Tiket yang sama bisa kamu bagikan kembali dengan menekan tombol Reshare selama status tiket masih Available (belum diklaim oleh orang lain",
		},
	],

	INSTRUCTION_LAZADA: [
		{
			id: 41,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/lazada-instruction-claim-ticket/new/1.png",
			content:
				"Salin kode voucher yang sudah dikirimkan melalui email atau lihat kode voucher di dalam list pesanan aplikasi Lazada kamu",
		},
		{
			id: 42,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/lazada-instruction-claim-ticket/new/2.png",
			content:
				"Buka aplikasi Female Daily, lalu buka menu FD Event pada homepage",
		},
		{
			id: 43,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/lazada-instruction-claim-ticket/new/3.png",
			content:
				"Pilih event yang sesuai dengan jenis tiket yang telah kamu beli",
		},
		{
			id: 44,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/lazada-instruction-claim-ticket/new/4.png",
			content:
				"Tempel kode voucher yang sudah kamu salin pada kolom yang sudah disiapkan pada halaman",
		},
		{
			id: 45,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/lazada-instruction-claim-ticket/new/5.png",
			content:
				"Pastikan kode yang kamu tempel sudah benar lalu tekan tombol <b>Claim</b>",
		},
		{
			id: 46,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/lazada-instruction-claim-ticket/new/6.png",
			content: "Tekan tombol <b>YA</b> untuk melanjutkan proses klaim",
		},
		{
			id: 47,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/lazada-instruction-claim-ticket/new/7.png",
			content:
				"Jika sudah berhasil, tiket kamu akan ditampilkan pada halaman My Tickets",
		},
		{
			id: 48,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/lazada-instruction-claim-ticket/new/8.png",
			content:
				"Untuk melihat halaman berisikan QR Code, Video Player, & Live Chat, klik tombol <b>Enter Event</b>",
		},
		{
			id: 49,
			img: "https://image.femaledaily.com/web-assets/xbeauty/ticketing/lazada-instruction-claim-ticket/new/9.png",
			content:
				"QR Code digunakan untuk menukarkan gelang di venue Female Daily X Beauty",
		},
	],
};
